import React from 'react';
import { Flex } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';

export const ConsolidatedStateLoading = () => (
	<Flex alignItems="center" justifyContent="center">
		<Spinner size="large" />
	</Flex>
);
